import { createIcon } from '@chakra-ui/react';

export const UserOutlineIcon = createIcon({
  displayName: 'UserOutlineIcon',
  path: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        // width="16"
        // height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <path
          d="M6.10671 7.74665C6.04004 7.73998 5.96004 7.73998 5.88671 7.74665C4.30004 7.69331 3.04004 6.39331 3.04004 4.79331C3.04004 3.15998 4.36004 1.83331 6.00004 1.83331C7.63337 1.83331 8.96004 3.15998 8.96004 4.79331C8.95337 6.39331 7.69337 7.69331 6.10671 7.74665Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.9402 3.16669C12.2335 3.16669 13.2735 4.21335 13.2735 5.50002C13.2735 6.76002 12.2735 7.78669 11.0268 7.83335C10.9735 7.82669 10.9135 7.82669 10.8535 7.83335"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.77348 10.2067C1.16014 11.2867 1.16014 13.0467 2.77348 14.12C4.60681 15.3467 7.61348 15.3467 9.44681 14.12C11.0601 13.04 11.0601 11.28 9.44681 10.2067C7.62014 8.98669 4.61348 8.98669 2.77348 10.2067Z"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.2266 13.8333C12.7066 13.7333 13.1599 13.54 13.5332 13.2533C14.5732 12.4733 14.5732 11.1866 13.5332 10.4066C13.1666 10.1266 12.7199 9.93998 12.2466 9.83331"
          stroke="#6E6789"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  ),
});
